/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orders: NonNullable<unknown> }} Lot_Debt_Fill_Over_DebtInputs */

const vi_lot_debt_fill_over_debt = /** @type {(inputs: Lot_Debt_Fill_Over_DebtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.orders} đơn được bù nhiều hơn số đang nợ — giảm bớt trước khi lưu, phần thừa sẽ không được ghi nhận.`)
};

/**

* @param {Lot_Debt_Fill_Over_DebtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_over_debt = /** @type {((inputs: Lot_Debt_Fill_Over_DebtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_Over_DebtInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_over_debt(inputs)
});